import { LuCircleCheck } from 'react-icons/lu';
import "./style.css";

const ProjectBenefits = ({ data }) => {
  if (!data?.items?.length) return null;
  return (
    <section className="project-case-card project-benefits">
      <h2 className="project-case-card__title">{data.title}</h2>

      <ul className="project-benefits__list">
        {data.items.map((item) => (
          <li className="project-benefits__item" key={item}>
            <LuCircleCheck />
            <span>{item}</span>
          </li>
        ))}
      </ul>
    </section>
  );
};

export default ProjectBenefits;
